
import React from 'react';

import { useSelector } from 'react-redux';
import { IReduxStateData } from '../interfaces/redux';
import { ABOUT_US_FULL_FIVE, ABOUT_US_FULL_FOUR, ABOUT_US_FULL_ONE, ABOUT_US_FULL_SIX, ABOUT_US_FULL_THREE, ABOUT_US_FULL_TITLE, ABOUT_US_FULL_TWO } from '../constant/menuAndProfile';

export default function AboutUs() {
    const globalState = useSelector((state: IReduxStateData) => state);
    return (
        <div className="container pt-5 pb-5">
            <div dangerouslySetInnerHTML={{ __html: ABOUT_US_FULL_TITLE[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: ABOUT_US_FULL_ONE[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: ABOUT_US_FULL_TWO[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: ABOUT_US_FULL_THREE[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: ABOUT_US_FULL_FOUR[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: ABOUT_US_FULL_FIVE[globalState?.selectedLang || ""] }} />

            <div dangerouslySetInnerHTML={{ __html: ABOUT_US_FULL_SIX[globalState?.selectedLang || ""] }} />
        </div>
    )
}
